const CTA_BORDER_RADIUS = '90px';

export default CTA_BORDER_RADIUS;
